import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import {
  MachineGroup,
  UpdateMachineGroupPayload,
} from "@src/types/namespace-configuration";

export interface UpdateMachineGroupResult {
  success: boolean;
  data?: MachineGroup;
  error?: string;
}

export const updateMachineGroupUseCase = async (
  groupId: string,
  payload: UpdateMachineGroupPayload,
): Promise<UpdateMachineGroupResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const machineGroup = await apiUseCases.patchUpdateMachineGroup(
      namespace,
      groupId,
      payload,
    );

    return {
      success: true,
      data: machineGroup,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update machine group")
        .message,
    };
  }
};
